import { Component } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { HelpComponent } from '../help/help.component';
@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent {
  constructor(public matDialog: MatDialog) { }
  openHelpPage(): void {
    const dialogRef = this.matDialog.open(HelpComponent, {
      width: '75%', disableClose: true, autoFocus: false, panelClass: 'nr-custom-general-dialog', id: 'help-component'
    });
  }
}
